import { render, staticRenderFns } from "./Section4.vue?vue&type=template&id=58539276&scoped=true"
import script from "./Section4.vue?vue&type=script&lang=js"
export * from "./Section4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58539276",
  null
  
)

export default component.exports